$(function () {
  'use strict';
  
  //////////////////////////////////////////////////////////////////////////////////////
  //
  // V A R I A B L E S
  //
  //////////////////////////////////////////////////////////////////////////////////////

  var $fn = {},
    $el = {
      window       : $(window),
      html         : $('html'),
      body         : $('body'),
      document     : $('.l-document'),
      recruitSlide : ''
    },
    param = {
        winW        : window.innerWidth || $el.window.width(),
        winH        : window.innerHeight || $el.window.height(),
        docW        : $el.document.outerWidth(),
        docH        : $el.document.outerHeight(),
    };




  //////////////////////////////////////////////////////////////////////////////////////
  //
  // C O M M O N
  //
  //////////////////////////////////////////////////////////////////////////////////////
    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {

    }


    /* ************************************************
      * link
      *
      * リンク
      *
     ************************************************* */
    $(document).on('click','.btn',function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $('.page-loading').removeClass('loaded');
        var anim = TweenMax.fromTo(".page-loading .bg", .5, {ease: Expo.easeOut, top: '100%'},{ease: Expo.easeOut, top: '0',
            onComplete:function () {
                window.location = url;
            }
        });
    });

    var $container = $(".l-instagram--ul");
    var html = "";
    if($('.l-instagram').length) {
        $.ajax({
            url: "http://localhost/turitoki/wp-content/themes/turitoki/inc/feed.php",//PHPファイルURL
            type: "POST",
            dataType: "json"
        }).done(function (data) {
            $.each(data.data, function (i, item) {
                var imgurl = item.images.low_resolution.url; //低解像度の画像のURLを取得
                console.log(imgurl);
                var link = item.link; //リンクを取得
                html += "<li class='gallery-ul-item'><a href='" + link + "' target='_blank'><img src='" + imgurl + "' class='object-fit-img'></a></li>";
            });
        }).fail(function () {
            //通信失敗時の処理
            html = "<li>画像を取得できません。</li>";
        }).always(function () {
            //通信完了時の処理
            $container.html(html);
        });
    };


    /* ************************************************
      * smoothScroll
      *
      * スムーススクロール
      *
     ************************************************* */
    $fn.smoothScroll = function () {
        $('body').on('click', 'a[href^="#"]', function () {
            var header_h = $('.l-header').innerHeight();
            var href= $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top-header_h;
            $('body,html').animate({scrollTop:position}, 1200, 'easeOutQuart');
            return false;
        });
    }


    /* ************************************************
   * scrollNavi
   *
   * スクロールでナビトグル
   *
  ************************************************* */

  //////////////////////////////////////////////////////////////////////////////////////
  //
  // E V E N T
  //
  //////////////////////////////////////////////////////////////////////////////////////


    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $target_parent = $('.about-image');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();
        var mainW = $target_parent.width();


        $target.css({
            height:mainImgW*ratio+'px'
        })

    };

    $fn.mainimgSize2 = function () {
        var $target = $('.main-carousel2');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();


        $target.css({
            height:mainImgW*ratio+'px'
        })

    };



  // objectFitImages('img.object-fit-img');
  $fn.smoothScroll();
  //$fn.linePos();



  /* resize
  ============================================================== */
  $el.window.resize('load', function () {
      $fn.mainimgSize();
      $fn.mainimgSize2();
  });





  /* scroll
  ============================================================== */
  $el.window.on('scroll touchmove', function () {
      param.scrollpos = amount;

      // $fn.scrollparallax();
      var amount = $(this).scrollTop();
      $fn.scrollNavi(amount);
      clearTimeout( param.timer );
      param.timer = setTimeout(function() {
          param.scrollpos = amount;
      }, 10 );

  });
    $fn.scrollNavi = function (scroll_amount) {
        var openFlag = false;
        $('.hidden-menu .category-box').each(function () {
            if($(this).attr('class').indexOf('open') !== -1){
                openFlag = true;
            }
        });
        if(scroll_amount > 50 && !openFlag){
            $('.l-header').addClass('scroll');
        }else if(scroll_amount <= 50 && !openFlag){
            $('.l-header').removeClass('scroll');
        }
    };
    $(document).on('scroll', function () {
        // if($('.cafe-image').length) {
        //     var wst = $('.cafe-image').offset().top - $el.window.scrollTop();
        //     $('.cafe-image', this).css('-webkit-transform', 'translate3d(0,' + wst / 10 + 'px,0)');
        // }
        // if($('.cafe-image2').length) {
        //     var wst2 = $('.cafe-image2').offset().top - $el.window.scrollTop();
        //     $('.cafe-image2', this).css('-webkit-transform', 'translate3d(0,' + wst2 / 10 + 'px,0)');
        // }
        // if($('.cafe-image3').length) {
        //     var wst3 = $('.cafe-image3').offset().top - $el.window.scrollTop();
        //     $('.cafe-image3', this).css('-webkit-transform', 'translate3d(0,' + wst3 / 10 + 'px,0)');
        // }
        //
        // if($('.tour-image').length) {
        //     var wst4 = $('.tour-image').offset().top - $el.window.scrollTop();
        //     $('.tour-image', this).css('-webkit-transform', 'translate3d(0,' + wst4 / 10 + 'px,0)');
        // }
        // if($('.tour-image2').length) {
        //     var wst5 = $('.tour-image2').offset().top - $el.window.scrollTop();
        //     $('.tour-image2', this).css('-webkit-transform', 'translate3d(0,' + wst5 / 10 + 'px,0)');
        // }

    });
    $('.toggle').on('click',function () {
        if( $('body').hasClass('open')){
            $('body').removeClass('open');
        }else{
            $('body').addClass('open');
        }
    });

});



// common
$(window).on("load",function(){

    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $('.l-document'),
            recruitSlide : ''
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            filter_index: ''

        };
    var anim = TweenMax.to(".page-loading figure", 1, {ease: Elastic.easeOut.config(1, 1), scale: 1,
        onComplete:function () {
            $fn.loadedAnimation();
        }
    });

    $fn.loadedAnimation  = function(){
        var anim = TweenMax.to(".page-loading figure", .5, {ease: Elastic.easeOut.config(1, 1), scale:0,opacity:0,delay:.3});
        var anim = TweenMax.to(".page-loading .bg", .5, {ease: Expo.easeOut, top: '-100%',delay:.8,
            onComplete:function () {
                $('.page-loading').addClass('loaded');

            }
        });

    };

    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();

        $target.css({
            height:mainImgW*ratio+'px'
        })

    };

    $fn.mainimgSize2 = function () {
        var $target = $('.main-carousel2');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();


        $target.css({
            height:mainImgW*ratio+'px'
        })

    };

    $fn.scrollNavi = function (scroll_amount) {
        var openFlag = false;
        $('.hidden-menu .category-box').each(function () {
            if($(this).attr('class').indexOf('open') !== -1){
                openFlag = true;
            }
        });
        if(scroll_amount > 100 && !openFlag){
            $('.l-header').addClass('scroll');
        }else if(scroll_amount <= 100 && !openFlag){
            $('.l-header').removeClass('scroll');
        }
    };

    $(document).on("click", ".filter li", function( e ) {
        var class_name = $(this).attr('class');
        if(class_name.indexOf('onair') === -1) {

            var index = $(this).index() - 1;

            var hidden_ul_height = $('.hidden-menu .category-box:eq(' + index + ')').outerHeight();


            var hidden_height = $('.hidden-menu').height();

            if (hidden_height <= 10) {

                $('.filter li').each(function () {
                    $(this).removeClass('active');
                });
                $('.hidden-menu .category-box:eq(' + index + ')').addClass('open');
                $('.modal_bg').addClass('open');
                $(this).addClass('active');


                var anim = TweenMax.to(".hidden-menu", .5, {ease: Power3.easeInOut, height: hidden_ul_height + 'px'});
                param.filter_index = index;
                $('.l-header').addClass('scroll');


            } else if (hidden_height > 0 && param.filter_index === index) {

                $('.filter li').each(function () {
                    $(this).removeClass('active');
                    $('.hidden-menu', this).removeClass('open');
                });
                $('.hidden-menu .category-box').each(function () {
                    $(this).removeClass('open');
                });
                $('.hidden-menu .category-box:eq(' + index + ')').removeClass('open');
                $('.modal_bg').removeClass('open');
                var anim = TweenMax.to(".hidden-menu", .3, {ease: Power3.easeInOut, height: 0});
                $('.l-header').removeClass('scroll');
                $fn.scrollNavi($el.window.scrollTop());
                param.filter_index = '';


            } else if (hidden_height > 0 && param.filter_index !== index) {

                $('.hidden-menu .category-box').each(function () {
                    $(this).removeClass('open');
                });
                $('.filter li').each(function () {
                    $(this).removeClass('active');
                });
                $(this).addClass('active');
                var anim = TweenMax.to(".hidden-menu", .5, {ease: Power3.easeInOut, height: hidden_ul_height + 'px'});

                $('.hidden-menu .category-box:eq(' + index + ')').addClass('open');
                param.filter_index = index;
            }
        }
    });


    $(document).on('click', '.modal_bg', function( e ) {
        var hidden_height = $('.hidden-menu').height();
        console.log(hidden_height);
        if (hidden_height >= 10) {
            $('.filter li').each(function () {
                $(this).removeClass('active');
                $('.hidden-menu', this).removeClass('open');
            });
            $('.hidden-menu .category-box').each(function () {
                $(this).removeClass('open');
            });
            $('.modal_bg').removeClass('open');
            var anim2 = TweenMax.to(".hidden-menu", .3, {ease: Power3.easeInOut, height: 0});
            $('.l-header').removeClass('scroll');

            $fn.scrollNavi($el.window.scrollTop());
            param.filter_index = '';
            console.log("aaaa");
        }

    } );
    $(document).on("click", ".hidden-menu", function( e ) {
        e.stopPropagation();
    } );
    $(document).on("click", ".l-header .onair-list", function( e ) {
        e.stopPropagation();
    } );



    $fn.indexSlider = function() {
        if ($('.main-carousel').length) {
            $fn.mainimgSize();
            var carousel = document.querySelector('.main-carousel');
            param.flkty = new Flickity(carousel, {
                imagesLoaded: true,
                percentPosition: false,
                autoPlay: true,
                friction: .4,
                contain: true,
                prevNextButtons : [ '<b>prev</b>', '<em>next</em>' ],
                pageDots: false,
                wrapAround: true,
                pauseAutoPlayOnHover: false,
                initialIndex: Math.floor( Math.random() * carousel.children.length )
            });

            param.flkty.on('select', function () {
            });
            // param.flkty.stopPlayer();
            var imgs = carousel.querySelectorAll('.carousel-cell img');
            var docStyle = document.documentElement.style;
            var transformProp = typeof docStyle.transform == 'string' ?
                'transform' : 'WebkitTransform';

            param.flkty.on('scroll', function () {
                param.flkty.slides.forEach(function (slide, i) {
                    var img = imgs[i],
                        x = 0;

                    if (0 === i) {
                        x = Math.abs(param.flkty.x) > param.flkty.slidesWidth ? ( param.flkty.slidesWidth + param.flkty.x + param.flkty.slides[param.flkty.slides.length - 1].outerWidth + slide.target ) : ( slide.target + param.flkty.x );
                    } else if (i === param.flkty.slides.length - 1) {
                        x = Math.abs(param.flkty.x) + param.flkty.slides[i].outerWidth < param.flkty.slidesWidth ? ( slide.target - param.flkty.slidesWidth + param.flkty.x - param.flkty.slides[i].outerWidth ) : ( slide.target + param.flkty.x );
                    } else {
                        x = slide.target + param.flkty.x;
                    }

                    img.style[transformProp] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
                    img.style.position = 'absolute';
                    img.style.left = param.leftPos + 'px';
                });
            });

            param.flkty.on( 'settle', function() {
                param.flkty.playPlayer();
            });



        }

    };

    $fn.secondSlider = function() {
        if ($('.main-carousel2').length) {
            $fn.mainimgSize2();
            var carousel = document.querySelector('.main-carousel2');
            param.flkty = new Flickity(carousel, {
                imagesLoaded: true,
                percentPosition: false,
                friction: .4,
                contain: true,
                prevNextButtons : [ '<b>prev</b>', '<em>next</em>' ],
                pageDots: false,
                wrapAround: true,
                autoPlay: true
            });

            param.flkty.on('select', function () {
            });
            var imgs = carousel.querySelectorAll('.carousel-cell img');
            var docStyle = document.documentElement.style;
            var transformProp = typeof docStyle.transform == 'string' ?
                'transform' : 'WebkitTransform';

            param.flkty.on('scroll', function () {
                param.flkty.slides.forEach(function (slide, i) {
                    var img = imgs[i],
                        x = 0;

                    if (0 === i) {
                        x = Math.abs(param.flkty.x) > param.flkty.slidesWidth ? ( param.flkty.slidesWidth + param.flkty.x + param.flkty.slides[param.flkty.slides.length - 1].outerWidth + slide.target ) : ( slide.target + param.flkty.x );
                    } else if (i === param.flkty.slides.length - 1) {
                        x = Math.abs(param.flkty.x) + param.flkty.slides[i].outerWidth < param.flkty.slidesWidth ? ( slide.target - param.flkty.slidesWidth + param.flkty.x - param.flkty.slides[i].outerWidth ) : ( slide.target + param.flkty.x );
                    } else {
                        x = slide.target + param.flkty.x;
                    }

                    img.style[transformProp] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
                    img.style.position = 'absolute';
                    img.style.left = param.leftPos + 'px';
                });
            });
            param.flkty.on( 'settle', function() {
                param.flkty.playPlayer();
            });
        }
    };


    $fn.indexSlider();
    $fn.secondSlider();

    // param.scrollpos = amount;
    //
    // // $fn.scrollparallax();
    // var amount = $(this).scrollTop();
    // $fn.scrollNavi(amount);
    // clearTimeout( param.timer );
    // param.timer = setTimeout(function() {
    //     param.scrollpos = amount;
    // }, 10 );


});

window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload();
    }
};